import { useState } from 'react';
import { gridSpacing } from 'constants/themeConstants';
import { useSelector } from 'store';
import { GridLegacy } from '@mui/material';
import { useGetFacilitiesQuery } from 'store/slices/apiV1/inventory';
import AddressCard from 'ui-component/cards/AddressCard';
import CreateCard from 'ui-component/cards/CreateCard';
import CreateUpdateFacilityDialog from 'views/inventory/components/CreateUpdateFacilityDialog';
import WithSkeleton from 'ui-component/extended/WithSkeleton';
import _ from 'lodash';

const InventoryAddresses = () => {
  const { activeOrgId } = useSelector((state) => state.org);
  const [newFacilityDialogOpen, setNewFacilityDialogOpen] = useState(false);
  const { data: stockLocations, isFetching } = useGetFacilitiesQuery({
    orgId: activeOrgId as string,
  });

  return (
    <GridLegacy container rowSpacing={gridSpacing} spacing={gridSpacing}>
      <WithSkeleton isLoading={isFetching} sx={{ ml: 1, mr: 1 }}>
        {isFetching ? (
          <GridLegacy item xs={3}>
            Nullam libero mauris, consequat quis.
          </GridLegacy>
        ) : (
          _.orderBy(stockLocations || [], ['externalName', 'name']).map(
            (address) => (
              <GridLegacy item xs={3} key={address.id}>
                <AddressCard location={address} clickable={false} />
              </GridLegacy>
            )
          )
        )}
      </WithSkeleton>
      <GridLegacy item xs={3}>
        <CreateCard
          onClick={() => {
            setNewFacilityDialogOpen(true);
          }}
          text="New Address"
        >
          <CreateUpdateFacilityDialog
            dialogOpen={newFacilityDialogOpen}
            orgId={activeOrgId || ''}
            onClose={() => setNewFacilityDialogOpen(false)}
          />
        </CreateCard>
      </GridLegacy>
    </GridLegacy>
  );
};

export default InventoryAddresses;
